import React, { useEffect, useState, useCallback } from "react";
import Box from "@mui/material/Box";
// DataGridFunction Component
import DataGridFunction from "../../components/datagridComponent/datagrid";
// postPlus button component
import PostPlusButton from "../../components/postPlusButton/PostPlusButton";
import UserAction from "../../stores/user/UserAction";
import LoadingIndicator from "../../components/loading-indicator/LoadingIndicator";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { connect } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate } from "react-router";
import MobileOffIcon from "@material-ui/icons/MobileOff";

import {
  Grid,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Checkbox,
} from "@mui/material";
// Nodafound component
import NoDataFound from "../../components/nodatafound/NoDataFound";
//AutoComplete Function
//SelectField Component
import MuiButton from "../../components/muiButton/MuiButton";
import AutoCompleteComponent from "../../components/autoCompleteComponent/Autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import LockResetIcon from "@mui/icons-material/LockReset";
import ResetPassword from "../../components/resetPassword/ResetPassword";
import ManageInfluenceUserPost from "../../components/manageInfluenceUserPost/ManageInfluenceUserPost";
import { GridToolbar } from "@mui/x-data-grid";
import InfluencerUserAction from "../../stores/influencerUser/InfluencerUserAction";
// mapstateto props function
const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [
    InfluencerUserAction.REQUEST_INFLUENCER_USER,
  ]),
  influencerUser: state.influencerUser.influencerUser || [],
});

//MANAGE USER
function ManageInfluencerUser(props) {
  const [open, setOpen] = useState(false);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [edit, setEdit] = useState(false);
  const [page_limit] = useState("none");
  const [searchUser, setSearchUser] = useState(null);
  const [enable] = useState();
  const [openCampaign, setOpenCampaign] = useState(false);
  const [userName, setUserName] = useState("");
  const [filterLoader, setFilterLoader] = useState(false);
  const [clearLoader, setClearLoader] = useState(false);

  const onFilterUser = (event, searchUser) => {
    setSearchUser(searchUser);
  };

  // post plus button close model
  const openCloseModal = useCallback((open) => {
    setOpen(open);
  }, []);

  const editMode = useCallback((edit) => {
    setEdit(false);
  }, []);

  function fetchInfluenceUser() {
    let params = {
      page_limit: "none",
      order_by: '[["created_on", "desc"]]',
    };
    props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
  }

  const [openPassword, setOpenPassword] = useState(false);

  useEffect(() => {
    fetchInfluenceUser();
  }, []);

  // Columns
  const columns = [
    {
      field: "sl_no",
      headerName: "SL NO",
      width: 150,
      // flex: 2,
      resizable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "id",
      headerName: "ID",
      hide: true,
      width: 150,
    },
    {
      field: "influencer_name",
      headerName: "Influencer Name",
      width: 150,
      // flex: 3.5,
    },
    {
      field: "firstName",
      headerName: "FirstName",
      width: 150,
      // flex: 3.5,
    },
    {
      field: "lastName",
      headerName: "LastName",
      width: 150,
      // flex: 3.5,
    },
    {
      field: "influencer_description",
      headerName: "Description",
      width: 150,
      // flex: 3.5,
    },
    {
      field: "organization_obj",
      headerName: "Organization",
      width: 150,
      hide: true,
    },
    {
      field: "organization_name",
      headerName: "Organization",
      width: 150,
    },
    {
      field: "contact_number",
      headerName: "Contact Number",
      width: 150,
      // flex: 3.5,
    },
    {
      field: "custom_fields",
      headerName: "custom_fields",
      width: 150,
      hide: true,
    },
    {
      field: "email_address",
      headerName: "Email",
      width: 150,
      // flex: 4,
      // flex: 1,
    },
    {
      field: "social_media_platforms",
      headerName: "Platform",
      width: 150,
      // flex: 3,
      //   resizable: false,
    },
    {
      field: "social_media_platforms_array",
      headerName: "Platform",
      width: 150,
      hide: true,
      // flex: 3,
      //   resizable: false,
    },
    {
      field: "audience_size",
      headerName: "Audience Size",
      // flex: 4,
      width: 150,
      resizable: false,
      // hide: true,
    },
    {
      field: "total_post",
      headerName: "Total Post",
      // flex: 4,
      width: 150,
      resizable: false,

      // hide: true,
    },
    {
      field: "pricing",
      headerName: "Pricing",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "category_name",
      headerName: "Category",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "category",
      headerName: "Category",
      // flex: 4,
      width: 150,
      resizable: false,
      hide: true,
    },

    {
      field: "status_name",
      headerName: "Status",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "status",
      headerName: "Status",
      // flex: 4,
      width: 150,
      resizable: false,
      hide: true,
    },

    {
      field: "influencer_score",
      headerName: "Influencer Score",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    // {
    //   field: "influencer_id",
    //   headerName: "Influencer ID",
    //   // flex: 4,
    //   width: 150,
    //   resizable: false,
    // },
    {
      field: "age",
      headerName: "Age",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "gender",
      headerName: "Gender",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "location",
      headerName: "Location",
      // flex: 4,
      width: 150,
      resizable: false,
    },

    {
      field: "marital_status",
      headerName: "Marital Status",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "languages",
      headerName: "Languages",
      // flex: 4,
      width: 150,
      resizable: false,
    },
    {
      field: "enabled",
      headerName: "Enabled",
      width: 150,
      resizable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Edit",
      cellClassName: "actions",
      width: 150,
      renderCell: (params) => (
        <IconButton title="Edit" sx={{ border: "0" }}>
          <FontAwesomeIcon
            onClick={(event) => {
              event.ignore = true;
              setEdit(true);
              setOpen(true);
              setEditRowsModel(params.row);
            }}
            icon={faPenToSquare}
            style={{ height: "20px", width: "20px", color: "#2a5e6c" }}
          ></FontAwesomeIcon>
        </IconButton>
      ),
    },
    {
      field: "reset",
      type: "actions",
      headerName: "Reset",
      width: 150,
      renderCell: (params) => (
        <IconButton
          title="Reset Password"
          sx={{ border: "0" }}
          onClick={(event) => {
            setOpenPassword(true);
            setEditRowsModel(params.row);
          }}
        >
          <LockResetIcon sx={{ color: "#2a5e6c" }}></LockResetIcon>
        </IconButton>
      ),
    },
  ];

  const { isRequesting } = props;

  useEffect(() => {
    if (!isRequesting) {
      setFilterLoader(false);
      setClearLoader(false);
    }
  }, [isRequesting]);

  let organizationList = [];
  if (props.organization.hits) {
    props.organization.hits.hits.forEach((val) => {
      organizationList.push({
        organization_id: val._id,
        organization_name: val._source.organization_name,
      });
    });
  }

  let category_array = [];
  if (props.categoryfilter.hits) {
    props.categoryfilter.hits.hits.map((value) => {
      return category_array.push({
        category_id: value._id,
        category_name: value._source.category_name,
      });
    });
  }

  function orgname_function(id) {
    let o_name = organizationList.filter((val) => {
      return val.organization_id === id ? id : "";
    });
    return o_name[0] ? o_name[0].organization_name : "";
  }

  function orgObj_function(id) {
    let o_name = organizationList.filter((val) => {
      return val.organization_id === id ? id : "";
    });
    return o_name[0] ? o_name[0] : "";
  }
  //  datagrid rows
  const rows = [];
  let i = 1;

  let statuslist = [];
  if (props.statusFilter.hits) {
    props.statusFilter.hits.hits.forEach((value) => {
      statuslist.push({
        status_id: value._id,
        status_name: value._source.status_name,
      });
    });
  }

  const returnStatusName = (statusId) => {
    let filtered_status =
      statuslist.length > 0 &&
      statuslist.filter((val) => {
        return val.status_id === statusId;
      });

    return filtered_status.length > 0 ? filtered_status[0].status_name : ``;
  };

  const returnCategoryNames = (category) => {
    return (
      category.length > 0 &&
      category.map((val) => {
        return val.category_name;
      })
    );
  };

  const returnStatusObj = (statusId) => {
    let filtered_status =
      statuslist.length > 0 &&
      statuslist.filter((val) => {
        return val.status_id === statusId;
      });

    return filtered_status.length > 0 ? filtered_status[0] : ``;
  };
  if (props.influencerUser.hits) {
    props.influencerUser.hits.hits.length > 0 &&
      props.influencerUser.hits.hits.map((item, index) => {
        rows.push({
          sl_no: item._id ? i++ : "",
          id: item._id,
          influencer_name: item._source.influencer_name,
          firstName: item._source.firstName,
          lastName: item._source.lastName,
          influencer_description: item._source.influencer_description,
          enabled: item._source.enabled === true ? "Enabled" : "Disabled",
          organization_name: orgname_function(
            item._source.attributes.organization_id
              ? item._source.attributes.organization_id
              : ""
          ),
          organization_obj: orgObj_function(
            item._source.attributes.organization_id
              ? item._source.attributes.organization_id
              : ""
          ),
          contact_number: item._source.contact_number,
          audience_size: item._source.audience_size,
          email_address: item._source.email_address,
          total_post: item._source.total_post,
          pricing: item._source.pricing,
          category: item._source.category,
          category_name: returnCategoryNames(item._source.category),
          status_name: returnStatusName(item._source.status),
          status: returnStatusObj(item._source.status),
          influencer_score: item._source.influencer_score,
          age: item._source.age,
          gender: item._source.gender,
          marital_status: item._source.marital_status,
          languages: item._source.languages,
          social_media_platforms_array: item._source.social_media_platforms,
          location: item._source.location,
          custom_fields: item._source.custom_fields,
          social_media_platforms: item._source.social_media_platforms.map(
            (val) => {
              return val.platform_name;
            }
          ),
        });
      });
  }

  //username dropdown list assign
  let userList = [];

  if (props.influencerUser.hits) {
    props.influencerUser.hits.hits.length > 0 &&
      props.influencerUser.hits.hits.map((item) => {
        return userList.push(item._source.influencer_name);
      });
  }
  userList = [...new Set(userList)];

  //Enabled dropDown list assign
  // const enabled = ["agent", "client", "Manager", "super-admin", "admin"];

  // ********************************************** FILTER Function
  const handleFilter = () => {
    let params = {};
    const filter = [];

    if (searchUser !== "") {
      {
        filter.push(
          `["influencer_name.keyword","must","","term","${searchUser}"]`
        );
      }
    }

    if (searchUser !== "") {
      params = {
        filters: `[${filter}]`,
        page_limit: `${page_limit}`,
        order_by: '[["created_on", "desc"]]',
      };
      // setFilterLoader(true);
      // setFilterClicked(true);
      props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
    } else {
      alert("Please add filters");
      params = {
        order_by: '[["created_on", "desc"]]',
        page_limit: `${page_limit}`,
      };
      props.dispatch(InfluencerUserAction.requestInfluencerUser(params));
    }
  };

  //*************************************** CLEAR Function
  const ClearState = () => {
    // clear state
    if (searchUser !== null) {
      setSearchUser(null);
    }

    setClearLoader(true);
    const params = {
      order_by: '[["created_on", "desc"]]',
      page_limit: "none",
    };
    fetchInfluenceUser(params);
  };

  const navigate = useNavigate();

  let platform_list_for_post = [];

  if (props.platformfilter.hits) {
    props.platformfilter.hits.hits.length > 0 &&
      props.platformfilter.hits.hits.map((item) => {
        platform_list_for_post.push({
          platform_id: item._id,
          platform_name: item._source.platform_name,
        });
      });
  }

  return (
    <React.Fragment>
      {/* Filter Container*/}
      <Grid
        container
        xl={12}
        lg={12}
        md={12}
        sm={12}
        justifyContent="space-between"
        pr={6}
      >
        <Grid item lg={2} md={4} sm={4} mt={1}>
          <AutoCompleteComponent
            value={searchUser}
            list={userList}
            // isOptionEqualToValue={(option, value) =>
            //   option.fullName === value.fullName
            // }
            // getOptionLabel={(option) =>
            //   option.fullName ? option.fullName : ""
            // }
            textFieldProps={{
              placeholder: "Influencer Name",
            }}
            handleChange={onFilterUser}
            size="small"
            width="100%"
          />
        </Grid>

        {/* <AutoCompleteComponent
                list={enabled}
                textFieldProps={{
                  placeholder: "Enabled/Disabled",
                }}
                handleChange={onFilterEnable}
                size="small"
              /> */}

        <Grid item lg={6} md={7} sm={7} container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            container
            spacing={1}
            justifyContent="flex-end"
            mt={0}
          >
            <Grid
              lg={8}
              sm={8}
              md={8}
              display={"flex"}
              justifyContent={"end"}
              mt={1}
              mr={2}
              sx={{ gap: 2 }}
            >
              <Grid lg={3} md={3} sm={3}>
                <MuiButton
                  width="100%"
                  loading={filterLoader && isRequesting}
                  name="Filter"
                  onClick={handleFilter}
                />
              </Grid>
              <Grid lg={3} md={3} sm={3}>
                <MuiButton
                  width="100%"
                  loading={clearLoader && isRequesting}
                  name="Clear"
                  onClick={ClearState}
                />
              </Grid>
            </Grid>

            {/* post button component*/}
            <Grid>
              <PostPlusButton
                open={open}
                openCloseModal={openCloseModal}
                editMode={editMode}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* user post modal screen */}

      <Dialog open={openCampaign} fullWidth maxWidth="sm">
        <DialogContent>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <h5>Do you like to assign campaign for {userName} ?</h5>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            size="small"
            onClick={() => {
              setOpenCampaign(false);
            }}
          >
            <ClearIcon />
          </Button>
          <Button
            size="small"
            onClick={() => {
              navigate("/InfluencersCampaigns");
            }}
          >
            <CheckIcon />
          </Button>
        </DialogActions>
      </Dialog>

      <ManageInfluenceUserPost
        open={open}
        onSubmit={() => {}}
        onClose={() => setOpen(false)}
        onNavigateCampaign={(value) => {
          setOpenCampaign(true);
          setUserName(value);
        }}
        platformList={platform_list_for_post}
        userList={userList}
        userEditData={editRowsModel}
        edit={edit}
        organization_array={organizationList ? organizationList : []}
        category_array={category_array ? category_array : []}
        statuslist={statuslist.length > 0 ? statuslist : []}
        customticketfields={props.customticketfields}
      />

      <ResetPassword
        open={openPassword}
        onClose={() => {
          setOpenPassword(false);
        }}
        projectEditData={editRowsModel}
        influencerUser={true}
      />

      <Grid item xl={12} lg={12} md={12} sm={12} xs={12} pr={1}>
        {/* loading icon */}
        <Box sx={{ width: "100%" }}>
          <LoadingIndicator isActive={isRequesting}>
            <DataGridFunction
              // GridToolbar={GridToolbar}
              columns={columns}
              rows={rows}
              rowHeight={60}
            />
          </LoadingIndicator>
        </Box>
      </Grid>
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(ManageInfluencerUser);
